/**
  Creates the sessionStorage key used to save the user's position
  in the workflow, specific to a given session
  WARNING: sessionStorage is a CACHE
  The source of truth is the API via the __currentQuestionId__ field
 */
const getProgressStorageKey = (transmissionId: string) =>
    `transmission_progress_${transmissionId}`

/**
 * Saves the currently displayed question locally (sessionStorage).
 *
 * Used in addition to the API, not as a replacement.
 * The API is always updated via PUT /progression.
 */
export const persistCurrentQuestion = (transmissionId: string, questionId: string) => {
    try {
        sessionStorage.setItem(getProgressStorageKey(transmissionId), questionId)
    } catch (e) {
        console.warn('Impossible de sauvegarder la position en cache:', e)
    }
}

/**
 * Retrieves the last question displayed for this broadcast.
 *
 * Use ONLY as a fallback if the API does not return a position.
 * The priority is: API > sessionStorage > automatic calculation.
 */
export const getPersistedQuestion = (transmissionId: string): string | null => {
    try {
        return sessionStorage.getItem(getProgressStorageKey(transmissionId))
    } catch (e) {
        return null
    }
}

/**
 * Deletes the saved position for this transmission.
 */
export const clearPersistedProgress = (transmissionId: string) => {
    try {
        sessionStorage.removeItem(getProgressStorageKey(transmissionId))
    } catch (e) {
        // Ignored
    }
}
